const englishAside: ILanguageAside = {
  aboutme: "About me",
  mytoolkit: "My Toolkit",
  courses: "Courses",
  projects: "Projects",
  resume: "Résumé",
};

import { Link } from "react-router-dom";

const englishHomepage: ILanguageHomepage = {
  whoami: "Who am I",
  whoami_intro: () => (
    <span>
      I'm a software engineer and computer science instructor at{" "}
      <a target="_blank" href="https://www.youtube.com/@cs50xemportugues">
        {" "}
        CS50x em Português
      </a>
      , Harvard University's computer science course in Portuguese.
    </span>
  ),
  whoami_tools: () => (
    <span>
      My main development tools are: Bash, C, JavaScript, Python, SQL, and more.
      To view a list of all of my development tools,{" "}
      <Link to="/toolkit">click here</Link>.
    </span>
  ),
  whoami_polyglot:
    "Fun fact: I can speak English, Portuguese, French, Spanish, and other 4 languages.",
  tutorials: "Latest Tutorials",
  latest_tutorial:
    "My latest tutorial: REST API's with NodeJS, Express, MongoDB, and TypeScript (in Portuguese).",
  experience: "Experience",
  job_title: "Software Engineer",
  experience1:
    "This is Harvard University's computer science course in Portuguese.",
  experience2: "This is a language learning platform",
  also_worked: "I have also worked for",
  projects: "Projects",
  view_projects: () => (
    <span>
      <strong>To view all my projects</strong>,{" "}
      <Link to="projects">click here</Link>.
    </span>
  ),
  education: "Education",
  i_graduated:
    "I graduated in the following Harvard University CS50 computer science courses",
  cs50x: "Introduction to Computer Science",
  cs50python: "Introduction to Programming with Python",
  cs50web: "Web Programming with Python and JavaScript",
  cs50ai: "Introduction to Artificial Intelligence with Python",
  ifes: "IFES '19 - Information Systems Bachelor's degree dropout",
};

const englishToolkit: ILanguageToolkit = {
  title: "These are the tools I use",
  description: "I have experience with these software development tools.",
  databases: "Databases",
  aiDataScience: "AI & Data Science",
  os: "Operating Systems",
  noVideo: "No video for this technology. 😔",
};

const englishCourses: ILanguageCourses = {
  title: "These are the courses I teach",
  topics: "Topics",
  languagePortuguese: "in Portuguese",
  languageEnglish: "in English",
  languageFrench: "in French",
  languageSpanish: "in Spanish",
};

const englishProjects: ILanguageProjects = {
  allProjects: "All Projects",
  title: "These are some projects I built",
  intro:
    "All of the projects are full stack and combine different technologies to create valuable products and services.",
  realClient: "Real Client Project",
  showall_filter: "Filter projects: ",
  viewLiveProject: "View Live Project",
  viewGithubCode: "View Github Code",
  technologies: "Technologies",
  description: "Description",
  features: "Features",
};

export const englishLanguage: ILanguage = {
  id: "english",
  aside: englishAside,
  homepage: englishHomepage,
  toolkit: englishToolkit,
  courses: englishCourses,
  projects: englishProjects,
};
